import { useState, useEffect } from "react";
import { useBach } from "@/context/BachContext";
import { Textarea } from "@/components/ui/textarea";
import { SaveBadge } from "@/components/shared";

export default function BachNotes() {
  const { profile, save, saveStatus } = useBach();
  const [val, setVal] = useState("");
  useEffect(() => { if (profile) setVal(profile.notes || ""); }, [profile]);
  return (
    <div className="max-w-3xl">
      <div className="flex items-end justify-between mb-8">
        <div><h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-[#2A181C]">Notes</h1><p className="text-[#7A686C] mt-2">A free space for everything else.</p></div>
        <SaveBadge status={saveStatus} />
      </div>
      <Textarea value={val} onChange={(e) => setVal(e.target.value)} onBlur={() => save({ notes: val })} rows={16}
        placeholder="Jot down ideas, reminders, links…" className="rounded-2xl bg-white border-[#EFE3DE] focus-visible:ring-[#D8BD9E]" data-testid="bach-notes-area" />
    </div>
  );
}
